import { useQuery } from '@tanstack/react-query';

type AdviceDto = {
  id: string;
  clientId: string;
  dataExportTemplateId?: string | null;
  dataUploadFileId?: string | null;
  content?: string | null;
  adviceClass?: string | null;
  summary?: string | null;
  createdAt?: string | null;
};

export function useGetAdvice(dataUploadFileId?: string) {
  const { data, isLoading, error, refetch } = useQuery<AdviceDto[]>({
    queryKey: ['advice', dataUploadFileId],
    enabled: !!dataUploadFileId,
  });

  return {
    advice: data ?? [],
    isLoading,
    error,
    refetch,
  };
}
